import React, { useMemo, useState, useEffect } from "react";
import queryString from "query-string";
import { useRouter } from "../../hooks/useRouter";

import { Page } from "./Page";
import { dataSourceV2 } from "commons-ui/core/DataSource";
import { MetaWrapper } from "../../components/Meta";
import Loading from "commons-ui/core/Loading";
import { useStore } from "../../context/state";



import "./ShippingEventView.module.scss";
import { mediaPath } from "../../constants";


export default function ShippingEventView({categoryList, productDictByCategory}) {
  const { dispatch, apiPath, ecommerceStoreId } = useStore();
  const [item, setItem] = useState({});
  const [deliveryOption, setDeliveryOption] = useState({});
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useRouter();

  const { id } = location.query;
  const filters = queryString.parse(location.search);

  const itemIdValue = item.ecommerce_store_delivery_option_event_id
  const itemIdValueParent = item.ecommerce_store_delivery_option_id
  const locationId = itemIdValue
  const locationParentId = itemIdValueParent

  const onBack = () => dispatch("/");

  const request = () => {
      dataSourceV2("ecommerce_store_delivery_option_event_list?slug=" + id, {url: apiPath}).then(v => {
          if (!v.message && v.item_list) {
              const item = v.item_list[0] || {}
              const deliveryOptionId = item["ecommerce_store_delivery_option_id"]

                    dataSourceV2(`ecommerce_store_delivery_option_list?ecommerce_store_delivery_option_id=${deliveryOptionId}`, {url: apiPath})
                      .then(k => {
                          if (!k.message && k.item_list && k.item_list.length ) {
                            const deliveryOption = k.item_list[0] || {}
                            const deliveryType = deliveryOption["delivery_type"] || deliveryOption["type"]
                            item["delivery_type"] = deliveryType
                            setDeliveryOption(deliveryOption);
                              setItem(item);
                              setLoading(false);
                          }
                          
                      });

          }
      });
  };

  const requestProductList = async (category) => {
    console.log(22, [locationId, locationParentId])
    const query = {
      size: 100,
      sort: [],
      _source: ["search_result_data"],
      query: {
        bool: {
          must: [],
          filter: [
            { term: { "search_data.ecommerce_store_id": ecommerceStoreId } },
            { terms: { "inventory_hidden.id_list": [locationId] }}
          ],
          must_not: [{ term: { "hidden.id_list": "default" } }],
        },
      },
    };

    return dataSourceV2(
      `ecommerce_product_view_list?is_search=true&postprocess=${locationId}&query=${JSON.stringify(
        query
      )}`,
      { url: apiPath }
    ).then((v) => {
      if (!v.message && v.item_list) {
        let itemList = v.item_list.map((data) => {
          const category_id_dict = data.category_id_dict || {};
          const version = data.version || {};

          return {
            ...version,
            category_id_dict,
            attribute_set_id: data.attribute_set_id,
            ecommerce_product_id: data.ecommerce_product_id,
          };
        });
        console.log("itemList", itemList)
        setProducts(itemList)
        return itemList;
      }
      return [];
    });
  };


  useEffect(() => {
      if (id) {
        request();
      }
  }, [id]);

  useEffect(() => {
    if (itemIdValue) {
      requestProductList()
    }
  }, [itemIdValue])

  if (loading || !item || !deliveryOption || Object.keys(item).length === 0 || Object.keys(deliveryOption).length === 0) {
    return <Loading />;
  }

  return (
    <MetaWrapper meta={{title: item.name, description: item.description, image: item.banner ? (mediaPath + item.banner) : undefined}}>
      <Page
        item={item}
        deliveryOption={deliveryOption}
        loading={loading}
        itemIdValue={itemIdValue}
        itemIdValueParent={itemIdValueParent}
        onBack={onBack}
        filters={filters}
        location={location}
        products={products}
      />
    </MetaWrapper>
  );
}
